module.exports = __webpack_public_path__ + "img/logo-ticketshop.5702c8d9.png";